"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _booking = require("./helpers/booking");
var _pricing = require("./helpers/pricing");
var _formatting = require("./helpers/formatting");
var _ProgressBar = _interopRequireDefault(require("./new-components/ProgressBar/ProgressBar"));
var DeadlineBox = function DeadlineBox(_ref) {
  var deadline = _ref.deadline,
    currency = _ref.currency,
    isLast = _ref.isLast,
    percentSum = _ref.percentSum,
    spacing = _ref.spacing,
    textSpace = _ref.textSpace,
    deadlineSum = _ref.deadlineSum;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "bar-deadline",
    style: {
      opacity: deadline.status === 'paid' ? 0.5 : 1,
      color: deadline.status === 'overdue' ? 'var(--color-error)' : 'var(--color-contrast-high)',
      textAlign: textSpace,
      width: isLast ? 'auto' : "".concat(percentSum * 2, "%"),
      left: isLast ? undefined : 0,
      right: isLast ? 0 : undefined
    }
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-md",
    style: {
      marginBottom: 0,
      color: 'inherit',
      position: 'relative',
      left: spacing
    }
  }, /*#__PURE__*/_react["default"].createElement("strong", null, (0, _moment["default"])(deadline.dueDate).format('DD MMM'))), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-md",
    style: {
      position: 'relative',
      left: spacing
    }
  }, (0, _pricing.formatCurrency)(deadlineSum / 100, currency)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "bar-tick",
    style: {
      right: isLast ? 0 : '50%',
      background: deadline.status === 'overdue' ? 'var(--color-error)' : 'var(--color-contrast-high)'
    }
  }));
};
DeadlineBox.propTypes = {
  deadline: _propTypes["default"].object.isRequired,
  currency: _propTypes["default"].string.isRequired,
  isLast: _propTypes["default"].bool.isRequired,
  percentSum: _propTypes["default"].number.isRequired,
  spacing: _propTypes["default"].string.isRequired,
  textSpace: _propTypes["default"].string.isRequired,
  deadlineSum: _propTypes["default"].number.isRequired
};
var PaymentBar = function PaymentBar(_ref2) {
  var order = _ref2.order,
    _ref2$nextAmount = _ref2.nextAmount,
    nextAmount = _ref2$nextAmount === void 0 ? 0 : _ref2$nextAmount,
    _ref2$barColor = _ref2.barColor,
    barColor = _ref2$barColor === void 0 ? 'var(--color-white)' : _ref2$barColor;
  var deadlines = (0, _booking.getDeadlinesWithStatus)(order);
  deadlines.sort(function (a, b) {
    return new Date(a.dueDate) - new Date(b.dueDate);
  });
  var paidAmount = (0, _booking.getPaidAmount)(order);
  var currency = order.currency;
  var paidPercent = paidAmount / order.gross * 100.0;
  var deadlineSum = 0;
  var percentSum = 0;
  var deadlineLength = deadlines.length;
  var deadlineBoxes = deadlines.map(function (deadline, index) {
    deadlineSum += deadline.amount;
    percentSum = deadlineSum / order.gross * 100.0;
    var isLast = index === deadlines.length - 1;
    var isFirst = index === 0;
    var isSecond = index === 1;
    var textSpace = 'center';
    if (isLast || isFirst) {
      textSpace = 'right';
    } else if (isSecond) {
      textSpace = 'left';
    }
    var spacing = 'auto';
    if (deadlineLength < 2) {
      spacing = 'auto';
    } else if (isFirst) {
      spacing = '-50%';
    } else if (isSecond && !isLast) {
      spacing = '50%';
    }
    return /*#__PURE__*/_react["default"].createElement(DeadlineBox, {
      key: deadline.dueDate,
      deadline: deadline,
      currency: currency,
      isLast: isLast,
      spacing: spacing,
      textSpace: textSpace,
      percentSum: percentSum,
      deadlineSum: deadlineSum
    });
  });
  var fullyPaid = order.gross <= paidAmount;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-c-payment-bar width-90%"
  }, fullyPaid ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      height: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement("h2", null, "Woohoo! You\u2019ve paid in full. See you soon!")) : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_ProgressBar["default"], {
    bars: [{
      background: 'd8-u-neon-green-bg',
      value: "".concat((0, _formatting.roundIfNeeded)(paidPercent, 2), "%")
    }, {
      background: 'd8-u-primary-bg',
      value: "".concat((0, _formatting.roundIfNeeded)(nextAmount / order.gross * 100), "%")
    }]
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, deadlineBoxes), /*#__PURE__*/_react["default"].createElement("div", {
    className: "bar-paid-box ".concat(paidPercent > 50 ? 'bar-paid-box-right' : ''),
    style: {
      left: "".concat(paidPercent, "%")
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "bar-tick bar-paid-tick"
  }), /*#__PURE__*/_react["default"].createElement("span", null, "You paid ", /*#__PURE__*/_react["default"].createElement("b", null, (0, _pricing.formatCurrency)(paidAmount / 100, currency)))), paidPercent < 75 && /*#__PURE__*/_react["default"].createElement("span", {
    className: "bar-total"
  }, (0, _pricing.formatCurrency)(order.gross / 100, currency))));
};
PaymentBar.propTypes = {
  order: _propTypes["default"].object.isRequired,
  nextAmount: _propTypes["default"].number,
  barColor: _propTypes["default"].string
};
var _default = exports["default"] = PaymentBar;